export default __webpack_public_path__ + "static/media/logo-color.c981052d.png";